<template>
    <el-button icon="ArrowDownBold" style="width:120px" @click="showDialog()">
        <span class="bold">{{ current.binanceConfig.leverage }}</span>
        <el-icon>
            <Close />
        </el-icon>
    </el-button>
    <el-tooltip content="刷新杠杆" effect="light" placement="top">
        <el-button icon="Refresh" @click="loadLeverage()" :loading="loading" />
    </el-tooltip>
    <el-dialog v-model="dialogVisible" title="调整杠杆" width="500" :close-on-click-modal="false" draggable>
        <div class="direct">杠杆倍数</div>
        <el-row style="margin-bottom:20px">
            <el-col :span="8" class="minusbtn">
                <el-button size="small" @click="mins()">-</el-button>
            </el-col>
            <el-col :span="8" style="text-align: center;" class="leverageinput">
                <el-input v-model="leverage" size="large" :min="1" :max="125" type="number" />
            </el-col>
            <el-col :span="8" class="plusbtn">
                <el-button size="small" @click="plus()">+</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-bottom:20px">
            <el-col :span="1"></el-col>
            <el-col :span="22">
                <el-slider v-model="leverage" :step="5" :min="0" :max="125" show-stops></el-slider>
            </el-col>
            <el-col :span="1"></el-col>
        </el-row>
        <div class="node">
            当逐仓有仓位时，只能提高杠杆倍数，请注意杠杆调整对仓位的影响。<br>
            杠杆调整将同时影响当前仓位和挂单的杠杆。
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()" :loading="loadingSave">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<style scoped>
.leverageinput>>>input {
    text-align: center !important;
    font-size: 36px;
}

.leverageinput>>>input::-webkit-outer-spin-button,
.leverageinput>>>input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.leverageinput>>>input[type=number] {
    -moz-appearance: textfield;
}

.leverageinput>>>.el-input__wrapper {
    background-color: none;
    box-shadow: none;
}

.direct {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
}

.leverage {
    display: flex;
    width: 100px;
}

.txt {
    flex: 1;
}

.icon {
    flex: 1;
    padding-top: 5px;
}

.plusbtn {
    text-align: left;
    padding-top: 7px;
}

.minusbtn {
    text-align: right;
    padding-top: 7px;
}

.node {
    font-size: 12px;
    color: #666;
    margin-bottom: 20px;
    padding: 0 20px;
}
</style>

<script setup>
import { ref, toRaw, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const current = ref(systemStore.currentusymbol)
const dialogVisible = ref(false)
const loading = ref(false)
const loadingSave = ref(false)
const leverage = ref(0)
const lastValidLeverage = ref(1)

// 监听 leverage 变化，确保只能输入 1-125 的整数
watch(leverage, (newVal) => {
    let num = parseInt(newVal)
    if (isNaN(num) || num < 1 || num > 125) {
        leverage.value = lastValidLeverage.value
    } else {
        leverage.value = num
        lastValidLeverage.value = num
    }
})

const submit = async () => {
    try {
        loadingSave.value = true

        // 调用API
       
        await systemStore.privateClient.setLeverage(current.value.symbol, leverage.value)
        ElMessage.success('保存成功')

        //更新缓存
        let _obj = {
            name: current.value.name,
            config: {
                marginType: current.value.binanceConfig.marginType,
                leverage: leverage.value,
            }
        }
        systemStore.updateBinanceConfig(_obj)
        loadingSave.value = false
        dialogVisible.value = false
    } catch (error) {
        ElMessage.error('保存失败' + error)
        loadingSave.value = false
        logStore.addLog({
            title: '保存杠杆失败',
            level: 'error',
            message: error
        })
    }
}

const loadLeverage = async () => {
    try {
        loading.value = true
        const postionRisk =  await systemStore.privateClient.positionsV2()
        const data = postionRisk.find(x => x.symbol == current.value.symbol)

        let _obj = {
            name: current.value.name,
            config: {
                marginType: data.marginType,
                leverage: data.leverage,
            }
        }
        systemStore.updateBinanceConfig(_obj)
        loading.value = false
    } catch (error) {
        loading.value = false
        ElMessage.error('更新失败' + error)
        loading.value = false
        logStore.addLog({
            title: '更新杠杆失败',
            level: 'error',
            message: error
        })
    }
}

const plus = () => {
    if (leverage.value < 125) {
        leverage.value += 1
        lastValidLeverage.value = leverage.value
    }
}

const mins = () => {
    if (leverage.value > 1) {
        leverage.value -= 1
        lastValidLeverage.value = leverage.value
    }
}

const showDialog = () => {
    leverage.value = parseInt(current.value.binanceConfig.leverage)
    lastValidLeverage.value = parseInt(current.value.binanceConfig.leverage)
    dialogVisible.value = true
}

</script>